import { ComponentProps, FunctionComponent } from "react";

import VergeLogo from "@ui/components/brand/theverge/VergeLogo/VergeLogo";
import OneTrustButton from "@ui/components/navigation/Footer/components/OneTrustButton";
import PmcPrivacyChoicesFooterLink from "@ui/components/navigation/Footer/components/PmcPrivacyChoicesLink";
import { PMC_LEGAL_URLS } from "@ui/components/navigation/Footer/data/pmcLegalUrls";
import { FooterConfig } from "@ui/context/component-config-context";
import vergeDark from "@ui/themes/theverge-dark.css";
import { NavItem } from "@voxmedia/duet-context/context/global-data-context";
import { RecursivePartial } from "@voxmedia/duet-utils/typescript";

const Logo: FunctionComponent<ComponentProps<typeof VergeLogo>> = () => (
  <VergeLogo fill={"white"} />
);

const DEFAULT_TOP_LINK_DATA = [
  {
    title: "Contact",
    href: "/contact",
  },
  {
    title: "Tip Us",
    href: "/c/tech/22579076/how-to-tip-the-verge-email-signal-and-more",
  },

  {
    title: "Community Guidelines",
    href: "/community-guidelines",
  },
  { title: "Archives", href: "/archives/full" },
  {
    title: "About",
    href: "/about-the-verge",
  },
  {
    title: "Ethics Statement",
    href: "/ethics-statement",
  },
  {
    title: "How We Rate and Review Products",
    href: "/pages/how-we-rate",
  },
];
const DEFAULT_BOTTOM_LINK_DATA = [
  {
    component: OneTrustButton,
    title: "Consent Management",
    href: "about:blank",
  },
  {
    title: "Terms of Use",
    href: PMC_LEGAL_URLS.termsOfUse,
  },
  {
    title: "Privacy Policy",
    href: PMC_LEGAL_URLS.privacyPolicy,
  },
  {
    title: "Your California Privacy Rights",
    href: PMC_LEGAL_URLS.californiaPrivacyRights,
  },
  {
    component: PmcPrivacyChoicesFooterLink,
    title: "Your Privacy Choices",
    href: PMC_LEGAL_URLS.yourPrivacyChoices,
  },
  {
    title: "Cookie Notice",
    href: PMC_LEGAL_URLS.cookieNotice,
  },
  {
    title: "AdChoices",
    href: PMC_LEGAL_URLS.adChoices,
  },
  {
    title: "Licensing FAQ",
    href: "https://www.voxmedia.com/pages/licensing",
  },
  {
    title: "Accessibility",
    href: PMC_LEGAL_URLS.accessibility,
  },
  {
    title: "Platform Status",
    href: "https://status.voxmedia.com",
  },
];

const footerConfig: RecursivePartial<FooterConfig> = {
  Logo: Logo,
  border: false,
  showNetworkSites: true,
  showPmcPrivacyBanner: true,
  getLinkData: (footerNav: NavItem[] | null) => {
    if (footerNav && footerNav.length > 0) {
      return [
        footerNav.map((item) => ({
          title: item.title,
          href: item.url,
        })),
        DEFAULT_BOTTOM_LINK_DATA,
      ];
    } else {
      return [DEFAULT_TOP_LINK_DATA, DEFAULT_BOTTOM_LINK_DATA];
    }
  },
  copyrightBrandName: "The Verge",
  networkSitesClassName: vergeDark,
  componentContext: {},
};

export default footerConfig;
